import React from 'react';
import GreyContainer from '../../../helpers/components/grey_container';
import { Col, Image, Row, Space } from 'antd';
import { Link } from 'react-router-dom';
import globalHelper from '../../../helpers/functions/global.helper';
import EntranceMotion from '../../../helpers/components/entrance_motion';
import { RightOutlined } from '@ant-design/icons';

const WhatToDoNext = ({ticket}) => {
    const insuranceAddOn = ticket?.add_ons?.find((addOn) => addOn?.add_on_section?.is_insurance === true);
    const hasInsuranceAddOn = insuranceAddOn != null;
    const insuranceFormUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSfXeOsXIC-4Ahyl_0FZjh7KVimd3bSfGN4BzCUS5d2aCiFpOA/viewform';
    const cardPadding = 18;
    const cardTitleSize = 18;
    return (
        <>
            <div style={{textAlign:'left'}}>
                <div style={{ textAlign : 'center', }}>
                    <span style={{fontWeight:500, color : 'var(--secondary-text-color)'}}>
                        We use Facial AI for check-ins, remember to upload your selfies with the link provided in your email.
                    </span>
                </div>
                <div style={{ marginTop : 24, }}>
                    <Row gutter={[20, 20]} justify={'center'}>
                        <Col xs={24} md={hasInsuranceAddOn ? 12 : 12}>
                            <Link to={`/ticket/face/${ticket?.unique_no}${ticket?.salt ?? ''}?is_salt=1`}>
                                <GreyContainer className="grey-card" height={"100%"} padding={0}>
                                    <div style={{width:'100%', display:'flex', flexDirection:'column', height:'100%'}}>
                                        <div style={{padding:cardPadding}}>
                                            <div>
                                                <div>
                                                    <Space style={{ color:'#4d4f5e' }}>
                                                        <div>
                                                            <span style={{fontSize:cardTitleSize, fontWeight:'bold',}}>Upload Your Selfies</span>
                                                        </div>
                                                        <div>
                                                            <RightOutlined className='right-arrow' />
                                                        </div>
                                                    </Space>
                                                </div>
                                                
                                            </div>
                                        </div>

                                        <div className='home-background' style={{textAlign:'center', overflow:'hidden', marginTop:'auto'}}>
                                            <EntranceMotion>
                                                <div style={{marginTop:12}}>
                                                    <Image className='features-image' src='/cibanners/selfie-guide.png' preview={false} style={{width: globalHelper?.isMobileScreen() ? 100 : 160}} />
                                                </div>
                                            </EntranceMotion>
                                        </div>
                                    </div>
                                </GreyContainer>
                            </Link>
                        </Col>

                        {
                            hasInsuranceAddOn &&
                            (
                                <Col xs={24} md={12}>
                                    <a href={insuranceFormUrl} target="_blank" rel="noreferrer noopener">
                                        <GreyContainer className="grey-card" height={"100%"} padding={0}>
                                            <div style={{width:'100%', display:'flex', flexDirection:'column', height:'100%'}}>
                                                <div style={{padding:cardPadding}}>
                                                    <div>
                                                        <div>
                                                            <Space style={{ color:'#4d4f5e' }}>
                                                                <div>
                                                                    <span style={{fontSize:cardTitleSize, fontWeight:'bold',}}>Purchased Insurance</span>
                                                                </div>
                                                                <div>
                                                                    <RightOutlined className='right-arrow' />
                                                                </div>
                                                            </Space>
                                                        </div>
                                                        <div style={{ marginTop : 4, }}>
                                                            <span style={{fontWeight:500, color : 'var(--secondary-text-color)'}}>
                                                                Click to submit your Tune Protect insurance details.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='home-background' style={{textAlign:'center', overflow:'hidden', marginTop:'auto'}}>
                                                    <EntranceMotion>
                                                        <div style={{marginTop:12}}>
                                                            <Image
                                                                className='features-image'
                                                                src='/logo/tune_protect.png'
                                                                preview={false}
                                                                style={{width: globalHelper?.isMobileScreen() ? 100 : 160}}
                                                            />
                                                        </div>
                                                    </EntranceMotion>
                                                </div>
                                            </div>
                                        </GreyContainer>
                                    </a>
                                </Col>
                            )
                        }
                    </Row>
                </div>
            </div>
        </>
    );
}

export default WhatToDoNext;
